module.exports = __webpack_public_path__ + "static/visual_6_1_do-d09b9fb62e7b2ec2dde43b07db94e486.png";